import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import interceptComponentWillUnmount from '@src/utils/intercept-component-will-unmount';
import { HashRouter as Router } from 'react-router-dom';

/**
 * 直接通过 append 方法添加到 body 子节点, 常用语弹窗
 * @param {object} ModalElement - react 组件, 常用语弹窗, 也可自行自定义类弹窗组件, 自定义组件请自行实现 onClose visible afterClose 的 props 方法
 * @param {object} componentContext - react 组件实例 this, 传入其他 this 时报错处理
 * @returns {{close: Function, promise: Promise}}
 *
 * {Function} close - 开发者可以通过 close() 方法直接调用, 这样便于自定义场景直接控制关闭弹窗
 * {Promise} promise - 开发者可以通过该方法指导当前弹窗什么时候关闭(销毁), 用法: promise.finally(()=> {...})
 *
 */
export default function append(ModalElement, componentContext) {
  const div = document.createElement('div');

  let close;

  const promise = new Promise(resolve => {
    let setVisibility;

    close = () => {
      setVisibility(false);
      return promise;
    };

    const afterClose = () => {
      ReactDOM.unmountComponentAtNode(div);
      if (div.parentNode) {
        div.parentNode.removeChild(div);
      }
      resolve();
    };

    const element = React.createElement(() => {
      const [visible, _setVisibility] = useState(true);
      setVisibility = _setVisibility;
      return <ModalElement visible={visible} onClose={() => setVisibility(false)} afterClose={afterClose} />;
    });

    ReactDOM.render(<Router>{element}</Router>, div);

    if (componentContext) {
      if (componentContext.__proto__ instanceof React.Component) {
        interceptComponentWillUnmount(componentContext, close);
      } else {
        throw new Error('modal: invalid component context. 请确保 append 传入中的 componentContext (常用 this) 为 react component 实例 this');
      }
    }
  });

  return { close, promise };
}
